import { Button, SingleColumnLayout } from '@salecycle/ui-component-library';
import { useClients } from 'core/app/AppContext';
import { ClientLevel } from 'core/types';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { MarketingPermissionsRoute } from '../../client-management/ui/pages/client-settings/marketing-permissions/routes';
import { useImportConsentContext } from '../context/ImportConsentContext';
import { FileManagementRoute } from '../routes';

const VerticalStack = styled.div`
  text-align: center;
`;

const Heading = styled.h1`
  font-size: 3.5rem;
  line-height: 4.2rem;
`;

const Subtext = styled.div`
  font-size: 1.4rem;
  margin: 4rem 0;
`;

const Image = styled.img.attrs({
  src: `/images/folder-complete.svg`,
})`
  width: 275px;
`;

const Spacer = styled.span`
  display: inline-block;
  width: 1rem;
`;

export function UploadSuccess() {
  const { clientId, clientLevel, successUploadCount } = useImportConsentContext();
  const { t } = useTranslation('fileManagement');
  const { getBrand } = useClients();
  const { push } = useHistory();
  const targetId =
    clientLevel === ClientLevel.BRAND
      ? getBrand(clientId).siteIds[0] // any representative site
      : clientId;
  const target = generatePath(MarketingPermissionsRoute.HOME, { siteId: targetId });

  return (
    <SingleColumnLayout align="center">
      <VerticalStack>
        <Image />
        <Heading>{t('success.title', { count: successUploadCount })}</Heading>
        <Subtext>{t('success.reminder')}</Subtext>
        <div>
          <Button variation="secondary" onClick={() => push(target)}>
            {t('success.buttons.settings')}
          </Button>
          <Spacer />
          <Button variation="primary" onClick={() => push(FileManagementRoute.IMPORT_ANALYSIS)}>
            {t('success.buttons.analysis')}
          </Button>
        </div>
      </VerticalStack>
    </SingleColumnLayout>
  );
}
